import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ROLES_VALUES } from '@/tools/values/staff.values';
import { STAFF_STORE } from '@/tools/store/staff.store';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { StaffService } from '@/tools/services/staff.service';

@Component({
  name: 'ed-edit-staff'
})
export default class EdEditStaffComponent extends Vue {

  /* Props */
  @Prop() readonly params: any;

  /* Data */
  public form: any = {}
  public saving: boolean = false;
  public roles: any = ROLES_VALUES;
  public roleSelected: string = '';

  /* Methods */
  sendInvitation() {
    this.saving = true;
    let formData = [];
    this.params.users.forEach(el => {
      formData.push({
        'email': el.email,
        'firstName': el.firstName,
        'lastName': el.lastName,
        'roleType': this.roleSelected
      })
    })
    StaffService.inviteUser(formData, this.params.orgId)
    .then(() => {
      this.saving = false;
      this.$store.commit(STAFF_STORE.MUTATIONS.RESET_USERS_M);
      this.$EdToast.create({ 
        msg:  `${this.$t('tools.staff.success.userInvited')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this.closeModal();
    }).catch(() => {
      this.saving = false;
      this.$EdToast.create({ 
        msg:  `${this.$t('tools.staff.errors.userNoInvited')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.closeModal();
    })
  }

  closeModal() {
    this.$EdModal.closeModal();
  }

  disableRoles(role) {
    if (role == 'STUDENT') {
      this.roles = this.roles.map(el => {
        if(el.value !== 'STUDENT') {
          return {...el, disabled: true}
        } else return el
      })
    } else {
      this.roles = this.roles.map(el => {
        if(el.value == 'STUDENT') {
          return {...el, disabled: true}
        } else return el
      })
    }
  }

  /* Hooks */
  mounted() {
    this.roleSelected = this.params.users[0].role;
    this.disableRoles(this.roleSelected);
  }
}